import gsap, { Power1 } from "gsap";

import { GetBy } from "../_app/cuchillo/core/Element";
import { isDebug } from '../_app/cuchillo/core/Basics';
import Header from "./Header";

export default class Preloader {
    _container;
    _progress;

    static init() {
        this._container = GetBy.id('Preloader');

        // if (isDebug) {
        //     this._container.style.display = "none"
        //     return;
        // }
    }

    static update(__progress) {
        if (isDebug) return;
    }

    static hide(__call) {
        // if (isDebug) {
        //     if (__call) __call();
        //     return;
        // }

        gsap.to(this._container, {
            duration: .5,
            opacity: 0,
            delay: 0,
            onComplete: () => {
                this._container.style.display = "none";
                if (__call) __call();
            }
        });
    }
}
